import { useCallback as e, useEffect as t, useLayoutEffect as n, useRef as r, useState as i } from "react";
import { jsx as a } from "react/jsx-runtime";
import o from "js-cookie";
import s from "axios";
//#region \0rolldown/runtime.js
var c = Object.create, l = Object.defineProperty, u = Object.getOwnPropertyDescriptor, d = Object.getOwnPropertyNames, f = Object.getPrototypeOf, p = Object.prototype.hasOwnProperty, m = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), h = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = d(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !p.call(e, s) && s !== n && l(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = u(t, s)) || r.enumerable
	});
	return e;
}, g = (e, t, n) => (n = e == null ? {} : c(f(e)), h(t || !e || !e.__esModule ? l(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), _ = /* @__PURE__ */ m(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), v = /* @__PURE__ */ m(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, w = c, T = s, E = n, D = d, O = i, k = h, A = m, j = r, M = o, N = a, P = f, F = !1;
		function ee(e) {
			return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), te(e) || x(e) === l;
		}
		function te(e) {
			return x(e) === u;
		}
		function ne(e) {
			return x(e) === c;
		}
		function I(e) {
			return x(e) === s;
		}
		function re(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function ie(e) {
			return x(e) === d;
		}
		function L(e) {
			return x(e) === i;
		}
		function ae(e) {
			return x(e) === h;
		}
		function R(e) {
			return x(e) === m;
		}
		function z(e) {
			return x(e) === r;
		}
		function B(e) {
			return x(e) === o;
		}
		function V(e) {
			return x(e) === a;
		}
		function H(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = w, e.ContextProvider = T, e.Element = E, e.ForwardRef = D, e.Fragment = O, e.Lazy = k, e.Memo = A, e.Portal = j, e.Profiler = M, e.StrictMode = N, e.Suspense = P, e.isAsyncMode = ee, e.isConcurrentMode = te, e.isContextConsumer = ne, e.isContextProvider = I, e.isElement = re, e.isForwardRef = ie, e.isFragment = L, e.isLazy = ae, e.isMemo = R, e.isPortal = z, e.isProfiler = B, e.isStrictMode = V, e.isSuspense = H, e.isValidElementType = b, e.typeOf = x;
	})();
})), y = /* @__PURE__ */ m(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = _() : t.exports = v();
})), b = /* @__PURE__ */ m(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), x = /* @__PURE__ */ m(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), S = /* @__PURE__ */ m(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), C = /* @__PURE__ */ m(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = x(), i = {}, a = S();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), w = /* @__PURE__ */ m(((e, t) => {
	var n = y(), r = b(), i = x(), a = S(), o = C(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: y,
			element: b(),
			elementType: x(),
			instanceOf: S,
			node: E(),
			objectOf: w,
			oneOf: C,
			oneOfType: T,
			shape: O,
			exact: k
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					} else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (M(s) !== e) {
					var c = N(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function y(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = M(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = M(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function x() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = M(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function S(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = F(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function C(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return N(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function w(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = M(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function T(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + P(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function E() {
			function e(e, t, n, r, i) {
				return A(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function D(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function O(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = M(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return D(r, a, o, l, N(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function k(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = M(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return D(o, s, c, d, N(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function A(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(A);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!A(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !A(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function j(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function M(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : j(t, e) ? "symbol" : t;
		}
		function N(e) {
			if (e == null) return "" + e;
			var t = M(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function P(e) {
			var t = N(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function F(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), T = /* @__PURE__ */ m(((e, t) => {
	var n = x();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), E = /* @__PURE__ */ g((/* @__PURE__ */ m(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = y();
		t.exports = w()(n.isElement, !0);
	} else t.exports = T()();
})))()), D = (e, n, { locale: r, authTokenBucket: i, partitionId: a, appId: o, onError: s, onCancel: c, user: l, hostUrl: u, environment: d, impersonationInformation: f, onDelete: p, apiBaseUrl: m }) => {
	t(() => {
		n("onError", s);
	}, [n, s]), t(() => {
		n("onCancel", c);
	}, [n, c]), t(() => {
		n("onDelete", p);
	}, [n, p]), t(() => {
		e("setLocale", r);
	}, [e, r]), t(() => {
		e("setApiConfig", {
			authTokenBucket: i,
			partitionId: a,
			environment: d,
			impersonationInformation: f,
			apiBaseUrl: m
		});
	}, [
		e,
		i,
		a,
		d,
		f,
		m
	]), t(() => {
		e("setAppId", o);
	}, [o, e]), t(() => {
		e("setUser", l);
	}, [e, l]), t(() => {
		e("setParentHostUrl", u);
	}, [e, u]);
}, O = "application/x-postmate-v1+json", k = 5, A = 0, j = function() {
	return ++A;
}, M = function() {
	var e;
	return I.debug ? (e = console).log.apply(e, arguments) : null;
}, N = function(e) {
	var t = document.createElement("a");
	t.href = e;
	var n = t.protocol.length > 4 ? t.protocol : window.location.protocol, r = t.host.length ? t.port === "80" || t.port === "443" ? t.hostname : t.host : window.location.host;
	return t.origin || n + "//" + r;
}, P = {
	handshake: 1,
	"handshake-reply": 1,
	call: 1,
	emit: 1,
	reply: 1,
	request: 1
}, F = function(e, t) {
	return !(typeof t == "string" && e.origin !== t || !e.data || typeof e.data == "object" && !("postmate" in e.data) || e.data.type !== O || !P[e.data.postmate]);
}, ee = function(e, t) {
	var n = typeof e[t] == "function" ? e[t]() : e[t];
	return I.Promise.resolve(n);
}, te = /* @__PURE__ */ function() {
	function e(e) {
		var t = this;
		this.parent = e.parent, this.frame = e.frame, this.child = e.child, this.childOrigin = e.childOrigin, this.events = {}, M("Parent: Registering API"), M("Parent: Awaiting messages..."), this.listener = function(e) {
			if (!F(e, t.childOrigin)) return !1;
			var n = ((e || {}).data || {}).value || {}, r = n.data, i = n.name;
			e.data.postmate === "emit" && (M("Parent: Received event emission: " + i), i in t.events && t.events[i].forEach(function(e) {
				e.call(t, r);
			}));
		}, this.parent.addEventListener("message", this.listener, !1), M("Parent: Awaiting event emissions from Child");
	}
	var t = e.prototype;
	return t.get = function(e) {
		var t = this;
		return new I.Promise(function(n) {
			var r = j();
			t.parent.addEventListener("message", function e(i) {
				i.data.uid === r && i.data.postmate === "reply" && (t.parent.removeEventListener("message", e, !1), n(i.data.value));
			}, !1), t.child.postMessage({
				postmate: "request",
				type: O,
				property: e,
				uid: r
			}, t.childOrigin);
		});
	}, t.call = function(e, t) {
		this.child.postMessage({
			postmate: "call",
			type: O,
			property: e,
			data: t
		}, this.childOrigin);
	}, t.on = function(e, t) {
		this.events[e] || (this.events[e] = []), this.events[e].push(t);
	}, t.destroy = function() {
		M("Parent: Destroying Postmate instance"), window.removeEventListener("message", this.listener, !1), this.frame.parentNode.removeChild(this.frame);
	}, e;
}(), ne = /* @__PURE__ */ function() {
	function e(e) {
		var t = this;
		this.model = e.model, this.parent = e.parent, this.parentOrigin = e.parentOrigin, this.child = e.child, M("Child: Registering API"), M("Child: Awaiting messages..."), this.child.addEventListener("message", function(e) {
			if (F(e, t.parentOrigin)) {
				M("Child: Received request", e.data);
				var n = e.data, r = n.property, i = n.uid, a = n.data;
				if (e.data.postmate === "call") {
					r in t.model && typeof t.model[r] == "function" && t.model[r](a);
					return;
				}
				ee(t.model, r).then(function(t) {
					return e.source.postMessage({
						property: r,
						postmate: "reply",
						type: O,
						uid: i,
						value: t
					}, e.origin);
				});
			}
		});
	}
	var t = e.prototype;
	return t.emit = function(e, t) {
		M("Child: Emitting Event \"" + e + "\"", t), this.parent.postMessage({
			postmate: "emit",
			type: O,
			value: {
				name: e,
				data: t
			}
		}, this.parentOrigin);
	}, e;
}(), I = /* @__PURE__ */ function() {
	function e(e) {
		var t = this, n = e.container, r = n === void 0 ? r === void 0 ? document.body : r : n, i = e.model, a = e.url, o = e.name, s = e.classListArray, c = s === void 0 ? [] : s, l = e.attributes, u = l === void 0 ? [] : l;
		return this.parent = window, this.frame = document.createElement("iframe"), this.frame.name = o || "", u.forEach(function(e) {
			t.frame.setAttribute(e.name, e.value);
		}), c.length > 0 && this.frame.classList.add.apply(this.frame.classList, c), r.appendChild(this.frame), this.child = this.frame.contentWindow || this.frame.contentDocument.parentWindow, this.model = i || {}, this.sendHandshake(a);
	}
	var t = e.prototype;
	return t.sendHandshake = function(t) {
		var n = this, r = N(t), i = 0, a;
		return new e.Promise(function(e, o) {
			n.parent.addEventListener("message", function t(i) {
				return F(i, r) ? i.data.postmate === "handshake-reply" ? (clearInterval(a), M("Parent: Received handshake reply from Child"), n.parent.removeEventListener("message", t, !1), n.childOrigin = i.origin, M("Parent: Saving Child origin", n.childOrigin), e(new te(n))) : (M("Parent: Invalid handshake reply"), o("Failed handshake")) : !1;
			}, !1);
			var s = function() {
				if (++i > k) return clearInterval(a), o("Handshake Timeout Reached");
				M("Parent: Sending handshake attempt " + i, { childOrigin: r }), n.child.postMessage({
					postmate: "handshake",
					type: O,
					model: n.model
				}, r);
			}, c = function() {
				s(), a = setInterval(s, 500);
			};
			n.frame.attachEvent ? n.frame.attachEvent("onload", c) : n.frame.addEventListener("load", c), M("Parent: Loading frame", { url: t }), n.frame.src = t;
		});
	}, e;
}();
I.debug = !1, I.Promise = function() {
	try {
		return window ? window.Promise : Promise;
	} catch {
		return null;
	}
}(), I.Model = /* @__PURE__ */ function() {
	function e(e) {
		return this.child = window, this.model = e, this.parent = this.child.parent, this.sendHandshakeReply();
	}
	var t = e.prototype;
	return t.sendHandshakeReply = function() {
		var e = this;
		return new I.Promise(function(t, n) {
			e.child.addEventListener("message", function r(i) {
				if (i.data.postmate) {
					if (i.data.postmate === "handshake") {
						M("Child: Received handshake from Parent"), e.child.removeEventListener("message", r, !1), M("Child: Sending handshake reply to Parent"), i.source.postMessage({
							postmate: "handshake-reply",
							type: O
						}, i.origin), e.parentOrigin = i.origin;
						var a = i.data.model;
						return a && (Object.keys(a).forEach(function(t) {
							e.model[t] = a[t];
						}), M("Child: Inherited and extended model from Parent")), M("Child: Saving Parent origin", e.parentOrigin), t(new ne(e));
					}
					return n("Handshake Reply Failed");
				}
			}, !1);
		});
	}, e;
}();
var re = { iframe: "iframe___rKs-w" }, ie = () => {}, L = ({ appId: r, iframeEl: a }) => {
	let [o, s] = i(!1), [c, l] = i(void 0);
	return n(() => {
		(async () => {
			console.log("Setting up Postmate parent"), l(await new I({
				container: a.current,
				url: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html",
				name: "connections-ui",
				classListArray: [re.iframe],
				model: { appId: r }
			})), s(!0);
		})();
	}, []), t(() => () => {
		c && c.destroy();
	}, [c]), {
		bindToChildEvent: e((e, t) => {
			if (!o) return;
			let n = t ?? ie;
			c.on(e, n);
		}, [o, c]),
		callChildFunction: e((e, t) => {
			o && c.call(e, t);
		}, [o, c]),
		postmateChild: c
	};
}, ae = E.default.shape({
	country: E.default.string,
	isAdmin: E.default.bool,
	userId: E.default.string,
	sellerId: E.default.string
}), R = (e) => (t, n, r) => {
	let i = t[n];
	if (!i && e) return /* @__PURE__ */ Error(`Invalid prop: No ${n} supplied to ${r}. ${n} is marked as required`);
	if (i && i.type !== "object") return /* @__PURE__ */ Error(`Invalid prop: ${n} supplied to ${r} is not a object type`);
	let a = i.props || {}, o = Object.keys(a), s = o.includes("authToken") && typeof a.authToken == "string", c = o.includes("auth0Token") && typeof a.auth0Token == "string", l = o.includes("auth0V3Token") && typeof a.auth0V3Token == "string";
	return !s && !(c || l) ? /* @__PURE__ */ Error(`${n} expects either authToken or one of the Auth0 tokens (auth0Token or auth0V3Token) props`) : null;
}, z = R(!1);
z.isRequired = R(!0);
var B = {
	propTypes: {
		authTokenBucket: z.isRequired,
		partitionId: E.default.number.isRequired,
		locale: E.default.oneOf(["en", "en-XA"]),
		appId: E.default.oneOf([
			"shipstation",
			"shipengine",
			"default"
		]),
		onError: E.default.func,
		user: ae,
		apiBaseUrl: E.default.string,
		hostUrl: E.default.string,
		environment: E.default.string,
		impersonationInformation: E.default.shape({
			expiration: E.default.string,
			sellerId: E.default.number
		})
	},
	defaultProps: {
		locale: "en",
		appId: "default",
		onError: () => {},
		hostUrl: "",
		environment: "",
		impersonationInformation: void 0
	}
}, V = {
	propTypes: {
		...B.propTypes,
		onCancel: E.default.func
	},
	defaultProps: {
		...B.defaultProps,
		onCancel: () => {}
	}
}, H = ["shipping", "fulfillment"], oe = { "provider-selector": "provider-selector___8D9e0" }, se = () => {}, U = (e) => {
	let { onProviderSelected: n, onComponentLoaded: i, onSeeServices: o, appId: s, providerList: c, disableAlreadyConnected: l, showSearchInput: u, componentUICustomization: d } = e, f = r(null), { callChildFunction: p, bindToChildEvent: m } = L({
		appId: s,
		iframeEl: f
	});
	return D(p, m, e), t(() => {
		m("onProviderSelected", n), m("onSeeServices", o), m("onComponentLoaded", i);
	}, [
		m,
		n,
		o,
		i
	]), t(() => {
		p("setProviderList", c), p("setShowSeeServices", !!o), p("setDisableAlreadyConnected", l), p("setShowSearchInput", u), p("setComponentUICustomization", d);
	}, [
		p,
		c,
		l,
		o,
		u,
		d
	]), t(() => {
		p("redirect", { formType: "providerSelector" });
	}, [p]), /* @__PURE__ */ a("div", {
		ref: f,
		className: oe["provider-selector"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
U.propTypes = {
	...V.propTypes,
	onProviderSelected: E.default.func,
	onComponentLoaded: E.default.func,
	onSeeServices: E.default.func,
	showSearchInput: E.default.bool,
	providerList: E.default.arrayOf(E.default.shape({
		alreadyConnected: E.default.bool,
		isLive: E.default.bool,
		providerApiCode: E.default.string,
		providerType: E.default.oneOf(H)
	})),
	disableAlreadyConnected: E.default.bool,
	componentUICustomization: E.default.shape({
		wrapperStyles: E.default.object,
		showGridTileRightIcon: E.default.bool
	})
}, U.defaultProps = {
	...V.defaultProps,
	onProviderSelected: se,
	showSearchInput: !0,
	providerList: [],
	componentUICustomization: {
		wrapperStyles: {},
		showGridTileRightIcon: !0
	},
	disableAlreadyConnected: !1
};
//#endregion
//#region library/provider-settings/provider-settings.module.less
var ce = { "provider-settings": "provider-settings___LuBZo" }, W = (e) => {
	window.location.href = e;
}, le = ({ url: e, params: t = {} }) => {
	let n = document.createElement("form");
	n.method = "post", n.action = e, Object.keys(t).forEach((e) => {
		let r = document.createElement("input");
		r.type = "hidden", r.name = e, r.value = t[e], n.appendChild(r);
	}), document.body.appendChild(n), n.submit(), n.parentNode.removeChild(n);
}, G = () => {}, K = (e) => {
	let { onSave: n, onCancel: i, onUpdateSellerData: o, appId: s, providerApiCode: c, providerType: l, accountId: u, sellerData: d, showReauthorizeStamps: f, showUsernameStamps: p } = e, m = r(null), { callChildFunction: h, bindToChildEvent: g } = L({
		appId: s,
		iframeEl: m
	});
	return D(h, g, e), t(() => {
		g("onSave", n), g("onCancel", i), g("onUpdateSellerData", o), g("onRegisterRedirect", W);
	}, [
		g,
		n,
		i,
		o
	]), t(() => {
		h("redirect", {
			providerApiCode: c,
			providerType: l,
			formType: "settings",
			data: { accountId: u }
		}), h("setSellerShipFroms", d?.shipFroms || []), h("setShowReauthorizeStamps", f), h("setShowUsernameStamps", p);
	}, [
		h,
		c,
		u,
		l,
		d,
		f,
		p
	]), /* @__PURE__ */ a("div", {
		ref: m,
		className: ce["provider-settings"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
K.propTypes = {
	...V.propTypes,
	onSave: E.default.func,
	onCancel: E.default.func,
	onUpdateSellerData: E.default.func,
	providerApiCode: E.default.string,
	providerType: E.default.oneOf(["shipping", "fulfillment"]),
	accountId: E.default.string,
	showReauthorizeStamps: E.default.bool,
	showUsernameStamps: E.default.bool
}, K.defaultProps = {
	...V.defaultProps,
	onSave: G,
	onCancel: G,
	onUpdateSellerData: G,
	providerApiCode: "",
	providerType: "",
	accountId: void 0,
	showReauthorizeStamps: !0,
	showUsernameStamps: !0
};
//#endregion
//#region library/provider-registration/provider-registration.module.less
var ue = { "provider-registration": "provider-registration___HwK8p" }, q = () => {}, J = (e) => {
	let { onRegisterSuccess: n, onRegisterFailure: i, onBack: o, appId: s, providerApiCode: c, providerType: l } = e, u = r(null), { callChildFunction: d, bindToChildEvent: f } = L({
		appId: s,
		iframeEl: u
	});
	return D(d, f, e), t(() => {
		f("onRegisterSuccess", n), f("onRegisterRedirect", W), f("onRegisterSubmitRedirectForm", le), f("onRegisterFailure", i), f("onBack", o);
	}, [
		f,
		n,
		i,
		o
	]), t(() => {
		d("redirect", {
			providerApiCode: c,
			providerType: l,
			formType: "registration"
		});
	}, [
		d,
		c,
		l
	]), /* @__PURE__ */ a("div", {
		ref: u,
		className: ue["provider-registration"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
J.propTypes = {
	...V.propTypes,
	onRegisterSuccess: E.default.func,
	onRegisterFailure: E.default.func,
	onBack: E.default.func,
	providerApiCode: E.default.string,
	providerType: E.default.oneOf(["shipping", "fulfillment"])
}, J.defaultProps = {
	...V.defaultProps,
	onRegisterSuccess: q,
	onRegisterFailure: q,
	onBack: q,
	providerApiCode: "",
	providerType: ""
};
//#endregion
//#region library/provider-deletion/provider-deletion.module.less
var de = { "provider-deletion": "provider-deletion___6iEjc" }, fe = () => {}, Y = (e) => {
	let { onRemoveAccount: n, onCancel: i, appId: o, providerApiCode: s, providerType: c, accountId: l } = e, u = r(null), { callChildFunction: d, bindToChildEvent: f } = L({
		appId: o,
		iframeEl: u
	});
	return D(d, f, e), t(() => {
		f("onRemoveAccount", n), f("onCancel", i);
	}, [
		f,
		n,
		i
	]), t(() => {
		d("redirect", {
			providerApiCode: s,
			providerType: c,
			formType: "deletion",
			data: { accountId: l }
		});
	}, [
		d,
		s,
		l,
		c
	]), /* @__PURE__ */ a("div", {
		ref: u,
		className: de["provider-deletion"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
Y.propTypes = {
	...V.propTypes,
	onRemoveAccount: E.default.func,
	onCancel: E.default.func,
	providerApiCode: E.default.string,
	providerType: E.default.oneOf(["shipping", "fulfillment"]),
	accountId: E.default.string
}, Y.defaultProps = {
	...V.defaultProps,
	onRemoveAccount: fe,
	onCancel: fe,
	providerApiCode: "",
	providerType: "",
	accountId: void 0
};
//#endregion
//#region library/marketplace-selector/marketplace-selector.module.less
var pe = { "marketplace-selector": "marketplace-selector___ysTpZ" }, me = () => {}, X = (e) => {
	let { appId: n, showSearchInput: i, marketplaceList: o, disableAlreadyConnected: s, onComponentLoaded: c, onMarketplaceSelected: l, componentUICustomization: u, displayAlternateGrid: d } = e, f = r(null), { callChildFunction: p, bindToChildEvent: m } = L({
		appId: n,
		iframeEl: f
	});
	return D(p, m, e), t(() => {
		m("onComponentLoaded", c), m("onMarketplaceSelected", l);
	}, [
		m,
		c,
		l
	]), t(() => {
		p("setShowSearchInput", i), p("setMarketplaceList", o), p("setDisableAlreadyConnected", s), p("setComponentUICustomization", u), p("setDisplayAlternateGrid", d);
	}, [
		p,
		o,
		s,
		i,
		u,
		d
	]), t(() => {
		p("redirect", { formType: "marketplaceSelector" });
	}, [p]), /* @__PURE__ */ a("div", {
		ref: f,
		className: pe["marketplace-selector"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
X.propTypes = {
	...V.propTypes,
	onMarketplaceSelected: E.default.func,
	onComponentLoaded: E.default.func,
	showSearchInput: E.default.bool,
	marketplaceList: E.default.arrayOf(E.default.shape({
		apiCode: E.default.string,
		marketplaceId: E.default.number,
		alreadyConnected: E.default.bool,
		isLive: E.default.bool,
		version: E.default.string
	})),
	componentUICustomization: E.default.shape({
		wrapperStyles: E.default.object,
		showGridTileRightIcon: E.default.bool
	}),
	disableAlreadyConnected: E.default.bool
}, X.defaultProps = {
	...V.defaultProps,
	onMarketplaceSelected: me,
	showSearchInput: !0,
	marketplaceList: [],
	componentUICustomization: {
		wrapperStyles: {},
		showGridTileRightIcon: !0
	},
	disableAlreadyConnected: !1
};
//#endregion
//#region library/connections-ui/postmate-child.js
var Z, Q = !1, he = {}, ge = ({ hashName: e, result: t }) => {
	let n = he[e];
	n && (delete he[e], n(t));
}, _e = (e) => Q || e === void 0 ? Q : (Q = !0, Z = e, Z.on("genericFunctionCallback", ge), Q), ve = (e, t, n) => {
	let r = `${e}${JSON.stringify(t)}`;
	he[r] = n, Z.call("genericFunction", {
		functionName: e,
		params: t,
		hashName: r
	});
}, ye = () => new Promise((e) => {
	ve("getUnsupportedMarketplaces", [], (t) => {
		e(t);
	});
}), be = { "marketplace-settings": "marketplace-settings___vTDKH" }, xe = (n) => {
	let { appId: i, marketplaceApiCode: o, storeGuid: s, redirectPath: c, onSave: l, onRedirect: u, version: d, onBack: f } = n, p = r(null), { callChildFunction: m, bindToChildEvent: h } = L({
		appId: i,
		iframeEl: p
	});
	D(m, h, n);
	let g = e((e) => {
		u(e), W(e);
	}, [u]);
	return t(() => {
		h("onSave", l), h("onRegisterRedirect", g), h("onBack", f);
	}, [
		h,
		l,
		f,
		g
	]), t(() => {
		m("setRedirectPath", c), m("redirect", {
			formType: "marketplaceConnection",
			marketplaceApiCode: o,
			storeGuid: s,
			redirectPath: c
		});
	}, [
		m,
		o,
		s,
		c
	]), t(() => {
		m("setVersion", d);
	}, [m, d]), /* @__PURE__ */ a("div", {
		ref: p,
		className: be["marketplace-settings"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
xe.propTypes = {
	...V.propTypes,
	marketplaceApiCode: E.default.string.isRequired,
	storeGuid: E.default.string,
	redirectPath: E.default.string,
	version: E.default.string,
	onBack: E.default.func,
	onRedirect: E.default.func
}, xe.defaultProps = {
	...V.defaultProps,
	storeGuid: void 0,
	redirectPath: "",
	version: "",
	onBack: () => {},
	onRedirect: () => {}
};
//#endregion
//#region library/marketplace-settings/style.module.less
var Se = { "marketplace-settings": "marketplace-settings___p2EtX" }, Ce = (e) => {
	let { appId: n, storeGuid: i, onSave: o, onCancel: s, marketplaceApiCode: c } = e, l = r(null), { callChildFunction: u, bindToChildEvent: d } = L({
		appId: n,
		iframeEl: l
	});
	return D(u, d, e), t(() => {
		d("onSave", o), d("onCancel", s);
	}, [
		d,
		o,
		s
	]), t(() => {
		u("redirect", {
			marketplaceApiCode: c,
			formType: "marketplaceSettings",
			storeGuid: i
		});
	}, [
		u,
		i,
		c
	]), /* @__PURE__ */ a("div", {
		ref: l,
		className: Se["marketplace-settings"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
Ce.propTypes = {
	...V.propTypes,
	storeGuid: E.default.string,
	marketplaceApiCode: E.default.string
}, Ce.defaultProps = {
	...V.defaultProps,
	storeGuid: void 0,
	marketplaceApiCode: void 0
};
//#endregion
//#region src/enums.js
var we = {
	providers: {
		express1: 1,
		stamps: 2,
		ups: 3,
		fedex: 4,
		endicia: 5,
		canadaPost: 11,
		firstMile: 16,
		lso: 18,
		royalMail: 20,
		australiaPost: 23,
		amazonBuyShipping: 27,
		fedexUK: 32,
		sendle: 33,
		hermes: 54,
		dhlExpress: 13,
		startrack: 43,
		newgistics: 15,
		dpd: 42,
		globalE: 2731,
		parcelforceRoyalMail: 4459
	},
	fillproviders: {
		fba: 1,
		fbaUK: 2,
		fbaCA: 3
	},
	marketplaces: {
		shipStation: 0,
		eBay: 1,
		amazon: 2,
		rakuten: 3,
		payPal: 6,
		volusion: 7,
		etsy: 8,
		googleCheckout: 9,
		zenCart: 10,
		payvment: 11,
		magentoGo: 12,
		bigCommerce: 13,
		shopify: 14,
		amazonUK: 15,
		osCommerce: 16,
		xCart: 17,
		channelAdvisor: 18,
		openCart: 19,
		memberly: 20,
		spree: 21,
		customStore: 22,
		threeDcart: 23,
		yahoo: 24,
		sears: 25,
		stitchLabs: 26,
		topShelf: 27,
		magento: 28,
		bizelo: 29,
		lemonStand: 30,
		highwire: 31,
		amazonCA: 32,
		goodsie: 33,
		newEgg: 34,
		ultraCart: 35,
		wooCommerce: 36,
		commerceInterface: 37,
		abanteCart: 38,
		sophio: 39,
		storenvy: 40,
		brightpearl: 41,
		amazonDE: 42,
		amazonES: 43,
		amazonFR: 44,
		amazonIT: 45,
		ecwidV1: 46,
		redditgifts: 47,
		wish: 48,
		soldsie: 49,
		bestBuy: 50,
		prestaShop: 51,
		eBayUK: 52,
		eBayCA: 53,
		mivaMerchant: 54,
		jane: 55,
		vault: 56,
		squarespace: 57,
		ameriCommerce: 59,
		skuVault: 60,
		foxyCart: 61,
		csCart: 62,
		bonanza: 63,
		mijoShop: 64,
		sellerActive: 65,
		moreCommerce: 66,
		tradeGecko: 67,
		grouponGoods: 68,
		reverb: 69,
		square: 70,
		choxi: 71,
		amazonJP: 72,
		neweggBusiness: 73,
		wooCommerceV2: 74,
		fullscreenDirect: 75,
		celery: 76,
		penny: 77,
		groopdealz: 78,
		crateJoy: 79,
		dearSystems: 80,
		freestyle: 81,
		sellBrite: 82,
		hatch: 83,
		zoey: 84,
		linnworks: 85,
		bigCartel: 86,
		amazonMX: 87,
		sureDone: 88,
		secureStore: 89,
		neweggCanada: 90,
		spreesy: 91,
		ecwid: 92,
		walmart: 93,
		mozu: 94,
		stripe: 95,
		tanga: 96,
		weebly: 97,
		labelApi: 98,
		eBayAU: 99,
		houzz: 100,
		tophatter: 101,
		odbc: 102,
		sparkShipping: 103,
		channelSale: 104,
		coreCommerce: 105,
		geekSeller: 106,
		sapAnywhere: 107,
		cin7: 108,
		bandcamp: 109,
		jet: 110,
		salesforceCommerceCloud: 111,
		revolutionParts: 112,
		amazonAU: 113,
		handshake: 114,
		acumatica: 115,
		facebook: 116,
		shipEngineApi: 118,
		wix: 119,
		overstock: 120,
		listingMirror: 123,
		ordertime: 128,
		volo: 129,
		inkSoft: 130,
		miraklBestBuyCA: 131,
		acumaticaV2: 132,
		visualSoft: 133,
		walmartCA: 134,
		salesforceCore: 135,
		notOnTheHighStreet: 136,
		customStore2: 138,
		cDiscount: 139,
		eBayFR: 141,
		oxatis: 142,
		google: 143,
		darty: 146,
		neto: 147,
		bigCommerceV3: 163,
		netsuite: 3693
	},
	integrations: {
		mailchimp: 4,
		quickbooks: 5,
		zapier: 9,
		ecomdash: 10,
		finale: 11,
		skuVault: 12,
		edesk: 15,
		gorgias: 16,
		google: 18
	},
	apiCodes: {
		providers: {
			australiaPost: "australia_post",
			canadaPost: "canada_post",
			endicia: "endicia",
			fedex: "fedex",
			firstMile: "firstmile",
			hermes: "hermes",
			intersoftRoyalMail: "intersoft_royalmail",
			lso: "lso",
			sendle: "sendle",
			stamps: "stamps_com",
			ups: "ups",
			globalE: "global_e",
			parcelforceRoyalMail: "parcelforce_royal_mail"
		},
		marketplaces: {
			amazon: "amazon",
			amazonAU: "amazon_au",
			amazonCA: "amazon_ca",
			amazonDE: "amazon_de",
			amazonES: "amazon_es",
			amazonFR: "amazon_fr",
			amazonIT: "amazon_it",
			amazonJP: "amazon_jp",
			amazonMX: "amazon_mx",
			amazonUK: "amazon_uk",
			bigCommerce: "bigcommerce",
			bigCommerceV3: "bigcommerce_v3",
			bonanza: "bonanza",
			channelAdvisor: "channeladvisor",
			mozu: "mozu",
			netsuite: "netsuite",
			shopify: "shopify",
			volusion: "volusion",
			wish: "wish",
			openCart: "opencart",
			payPal: "paypal",
			odbc: "odbc",
			tanga: "tanga",
			magento: "magento",
			xcart: "x-cart",
			prestaShop: "prestashop"
		}
	}
}, Te = {
	marketplaceId: we.marketplaces.bigCommerce,
	name: "BigCommerce",
	finalOauthEndpoint: "/api/marketplace/BigCommerce/ProcessBcV2Store",
	parseCookie: (e) => decodeURIComponent(e).split(".")[1]
}, Ee = "authorization-token", De = "https://ship*.shipstation.com", Oe = async (e, t, n, r) => (await s({
	url: `${De.replace(/\*/, e)}${n}`,
	method: "POST",
	headers: { [Ee]: t },
	data: r
})).data, ke = "bigcommerce-token", Ae = "datadrivenoauth-token", je = [ke, Ae];
function Me(e) {
	switch (e.toString()) {
		case "14": return "Shopify";
		case "161": return "OAuth Dummy";
		default: return "your store";
	}
}
var Ne = (e) => {
	try {
		let t = window.parent.location.hostname.split("."), n = `${t[t.length - 2]}.${t[t.length - 1]}`;
		o.remove(e, {
			path: "/",
			domain: n
		});
	} catch {}
}, Pe = {
	[Ae]: async ({ cookieValue: e, onSuccess: t }) => {
		let n = e;
		t({
			marketplaceId: n,
			name: Me(n)
		});
	},
	[ke]: async ({ cookieValue: e, onSuccess: t, onFailure: n, partitionId: r, authToken: i }) => {
		let { marketplaceId: a, name: o } = Te;
		try {
			await Oe(r, i, Te.finalOauthEndpoint, { cookieContents: Te.parseCookie(e) }), t({
				marketplaceId: a,
				name: o
			});
		} catch (e) {
			let t = e?.response?.data?.Message || e.message;
			console.log(t), n({
				marketplaceId: a,
				name: o,
				errorMessage: t
			});
		}
	}
}, Fe = async (e, t, n, r) => {
	je.forEach(async (i) => {
		try {
			let a = o.get(i), s = Pe[i];
			a && s && await s({
				cookieValue: a,
				partitionId: e,
				authToken: t,
				onSuccess: n,
				onFailure: r
			});
		} catch (e) {
			r({ errorMessage: e?.message || e });
		}
		Ne(i);
	});
}, Ie = () => {
	let e = r(!1);
	return t(() => (e.current = !0, () => {
		e.current = !1;
	}), []), e;
}, Le = (...t) => {
	let n = Ie(), [r, a] = i(...t);
	return [r, e((e) => {
		if (n.current) return a(e);
	}, [n])];
}, Re = () => new Promise((e) => {
	let t = setInterval(() => {
		ve("isLaunchDarklyInitialized", [], (n) => {
			n && (e(), clearInterval(t));
		});
	}, 200);
}), $ = (e) => {
	let { appId: n, onInitialized: o } = e, [s, c] = i(!1), [l, u] = Le(!1), d = r(null), { callChildFunction: f, bindToChildEvent: p, postmateChild: m } = L({
		appId: n,
		iframeEl: d
	});
	D(f, p, e);
	let h = _e(m);
	return t(() => {
		l || !h || Re().then(() => u(!0));
	}, [
		l,
		u,
		h
	]), t(() => {
		s || !d || !h || !l || (c(!0), o && o());
	}, [
		s,
		c,
		d,
		o,
		h,
		l
	]), /* @__PURE__ */ a("div", {
		ref: d,
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html",
		style: { display: "none" }
	});
};
$.propTypes = {
	...B.propTypes,
	onInitialized: E.default.func
}, $.defaultProps = {
	...B.defaultProps,
	onInitialized: () => {}
};
//#endregion
//#region library/integrations-connection/style.module.less
var ze = { "integrations-connection": "integrations-connection___awBtp" }, Be = (e) => {
	let { appId: n, integrationAppId: i } = e, o = r(null), { callChildFunction: s, bindToChildEvent: c } = L({
		appId: n,
		iframeEl: o
	});
	return D(s, c, e), t(() => {
		c("onRegisterRedirect", W);
	}, [c]), t(() => {
		s("redirect", {
			formType: "integrationsConnection",
			integrationAppId: i
		});
	}, [s, i]), /* @__PURE__ */ a("div", {
		ref: o,
		className: ze["integrations-connection"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
Be.propTypes = {
	...V.propTypes,
	integrationAppId: E.default.number.isRequired
}, Be.defaultProps = { ...V.defaultProps };
//#endregion
//#region library/integrations-settings/style.module.less
var Ve = { "integrations-settings": "integrations-settings___KLnKL" }, He = () => {}, Ue = (e) => {
	let { appId: n, integrationAppId: i, onDelete: o, sellerStores: s } = e, c = r(null), { callChildFunction: l, bindToChildEvent: u } = L({
		appId: n,
		iframeEl: c
	});
	return D(l, u, e), t(() => {
		u("onDelete", o), u("onRegisterRedirect", W);
	}, [u, o]), t(() => {
		l("redirect", {
			formType: "integrationsSettings",
			integrationAppId: i
		}), l("setSellerStores", s);
	}, [
		l,
		i,
		s
	]), /* @__PURE__ */ a("div", {
		ref: c,
		className: Ve["integrations-settings"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
Ue.propTypes = {
	...V.propTypes,
	integrationAppId: E.default.number.isRequired,
	onDelete: E.default.func.isRequired,
	sellerStores: E.default.arrayOf(E.default.shape({
		name: E.default.string,
		id: E.default.number
	}))
}, Ue.defaultProps = {
	...V.defaultProps,
	storeGuid: void 0,
	redirectPath: "",
	onBack: He,
	sellerStores: []
}, Object.freeze([]), Object.freeze({});
var We = () => {}, Ge = (e) => {
	let { appId: n, providerApiCode: i, onSave: o } = e, s = r(null), { callChildFunction: c, bindToChildEvent: l } = L({
		appId: n,
		iframeEl: s
	});
	return D(c, l, e), t(() => {
		l("onSave", o);
	}, [l, o]), t(() => {
		c("redirect", {
			formType: "termsAndConditions",
			providerApiCode: i
		});
	}, [c, i]), /* @__PURE__ */ a("div", {
		ref: s,
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
Ge.propTypes = {
	...V.propTypes,
	providerApiCode: E.default.string.isRequired,
	onSave: E.default.func
}, Ge.defaultProps = {
	...V.defaultProps,
	onSave: We
};
//#endregion
//#region library/provider-services/provider-services.module.less
var Ke = { "provider-services": "provider-services___7G7Wh" }, qe = () => {}, Je = (e) => {
	let { appId: n, selectedProvider: i, providerServiceList: o, onContinue: s, onBack: c } = e, l = r(null), { callChildFunction: u, bindToChildEvent: d } = L({
		appId: n,
		iframeEl: l
	});
	return t(() => {
		d("onContinue", s), d("onBack", c);
	}, [
		d,
		s,
		c
	]), D(u, d, e), t(() => {
		u("setSelectedProvider", i), u("setProviderServiceList", o);
	}, [
		u,
		i,
		o
	]), t(() => {
		u("redirect", { formType: "providerServices" });
	}, [u]), /* @__PURE__ */ a("div", {
		ref: l,
		className: Ke["provider-services"],
		id: "iframe",
		src: "https://cdn.shipstation.com/connections-ui/2026_06_03_08_27_PM/index.html"
	});
};
Je.propTypes = {
	...V.propTypes,
	onContinue: E.default.func,
	onBack: E.default.func,
	selectedProvider: E.default.shape({
		providerApiCode: E.default.string,
		providerType: E.default.oneOf(H)
	}),
	providerServiceList: E.default.arrayOf(E.default.shape({
		name: E.default.string,
		description: E.default.string,
		service_code: E.default.string,
		international: E.default.bool
	}))
}, Je.defaultProps = {
	...V.defaultProps,
	selectedProvider: {},
	providerServiceList: [],
	onContinue: qe,
	onBack: qe
};
//#endregion
//#region library/carrier-cookie-checker/index.js
var Ye = "datadrivencarrieroauth-token", Xe = we.providers.ups, Ze = (e) => {
	switch (e) {
		case Xe: return "UPS";
		default: return;
	}
}, Qe = (e, t) => {
	let n = t.split("."), r = `${n[n.length - 2]}.${n[n.length - 1]}`;
	o.remove(e, {
		path: "/",
		domain: r
	});
}, $e = ({ onSuccess: e = We, onFailure: t = We }) => {
	let n = o.get(Ye);
	if (!n) return;
	let r = {
		carrierId: n,
		name: Ze(Number(n))
	};
	try {
		return Qe(Ye, window.location.hostname), e(r);
	} catch {
		return t(r);
	}
}, et = U, tt = K, nt = J, rt = Y, it = X, at = ye, ot = xe, st = Ce, ct = Fe, lt = $, ut = Be, dt = Ue, ft = Ge, pt = Je, mt = $e;
//#endregion
export { mt as CarrierCookieChecker, lt as ConnectionsUI, ut as IntegrationsConnection, dt as IntegrationsSettings, ot as MarketplaceConnection, ct as MarketplaceCookieChecker, it as MarketplaceSelector, st as MarketplaceSettings, rt as ProviderDeletion, nt as ProviderRegistration, et as ProviderSelector, pt as ProviderServices, tt as ProviderSettings, ft as TermsAndConditions, at as getUnsupportedMarketplaces };

//# sourceMappingURL=index.js.map